import track from 'react-tracking';
import {
  CurrentTransactionWrapper,
  LoadingTextWrapper,
  DeleteButton,
} from './styled';
import TrashIconSVG from '@assets/images/icons/legacy/trash.svg';
import { toSignificant } from '@simplywallst/formatting';
import DataTable from '@components/DataTable';
import { useTracking } from 'react-tracking';

interface Props {
  portfolioId: string;
  itemId: string;
  companyId: string;
  isUpdatingTransaction: boolean;
  transactions: {
    transactionId: string;
    transactionType: string;
    transactionDate: number;
    transactionAmount: number;
    transactionCost: number;
    isRemoving?: boolean;
  }[];
  handleRemoveTransaction: (args: {
    portfolioId: string;
    itemId: string;
    companyId: string;
    transactionId: string;
  }) => void;
}
export function CurrentTransactions({
  itemId,
  portfolioId,
  companyId,
  isUpdatingTransaction,
  transactions,
  handleRemoveTransaction,
}: Props) {
  const { trackEvent } = useTracking();

  const formatWithZeros = (n, zeroCount = 1) =>
    ('0000'.slice(0, zeroCount) + n).slice(-(zeroCount + 1));

  const getUTCDate = (date) => {
    const dd = formatWithZeros(date.getUTCDate());
    const mm = formatWithZeros(date.getUTCMonth() + 1);
    const yyyy = formatWithZeros(date.getUTCFullYear(), 3);
    return `${dd}/${mm}/${yyyy}`;
  };
  return (
    <CurrentTransactionWrapper>
      <h4>Current Transactions</h4>
      {isUpdatingTransaction && (
        <LoadingTextWrapper>{'Loading Transactions...'}</LoadingTextWrapper>
      )}
      {!isUpdatingTransaction && (
        <DataTable columnWidths="2, 2, 2, 3, 1" light>
          <thead>
            <tr>
              <th>Date</th>
              <th>Type</th>
              <th>Shares</th>
              <th>Cost</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {transactions &&
              transactions.map((txn) => (
                <tr key={`${itemId}-${txn.transactionId}`}>
                  <td>{getUTCDate(new Date(txn.transactionDate))}</td>
                  <td>{txn.transactionType}</td>
                  <td>{txn.transactionAmount}</td>
                  <td>
                    {txn.transactionCost.toLocaleString
                      ? txn.transactionCost.toLocaleString()
                      : toSignificant(txn.transactionCost, 2)}
                  </td>
                  {!txn.isRemoving && handleRemoveTransaction && (
                    <td>
                      <DeleteButton
                        onClick={() => {
                          handleRemoveTransaction({
                            portfolioId,
                            itemId,
                            companyId,
                            transactionId: txn.transactionId,
                          });
                          trackEvent({
                            action: 'delete',
                          });
                        }}
                        title={'Remove Transaction'}
                      >
                        <TrashIconSVG />
                      </DeleteButton>
                    </td>
                  )}
                  {txn.isRemoving && <td>{'Deleting...'}</td>}
                </tr>
              ))}
          </tbody>
        </DataTable>
      )}
    </CurrentTransactionWrapper>
  );
}

export default track({
  type: 'track',
})(CurrentTransactions) as typeof CurrentTransactions;
